export const US_ONLY_BOOKS = ['the-new-girl-code'];
